import { FC, ReactElement } from 'react';

import { Flex } from 'antd';
import classNames from 'classnames';

import styles from './TimeLineItem.module.scss';

interface ITimeLineItemProps {
	icon: ReactElement;
	isActive: boolean;
	title: string;
	description: string;
	onClick?: () => void;
}

export const TimeLineItem: FC<ITimeLineItemProps> = ({
	icon,
	isActive,
	title,
	description,
	onClick,
}) => {
	return (
		<div
			className={classNames(styles['time-line-item'], {
				[styles['time-line-item-active']]: isActive,
			})}
			onClick={() => isActive && onClick?.()}
		>
			{icon}
			<Flex gap={2} vertical>
				<p className={styles['title']}>{title}</p>
				<p className={styles['description']}>{description}</p>
			</Flex>
		</div>
	);
};
